import { executeStatusEnum } from '../../enum';
export default function (_ref) {
  var handleSearch = _ref.handleSearch;
  var FILTER_ITEMS = [{
    type: 'input',
    label: '简述：',
    prop: 'title',
    attrs: {
      placeholder: '请输入简述：',
      clearable: true,
      size: 'small'
    },
    events: {
      change: function change(value) {
        return handleSearch({
          title: value
        });
      }
    }
  }, {
    type: 'select',
    label: '执行状态：',
    prop: 'exeStatus',
    attrs: {
      placeholder: '请选择执行状态',
      size: 'small',
      clearable: true
    },
    options: executeStatusEnum,
    events: {
      change: function change(value) {
        return handleSearch({
          exeStatus: value
        });
      }
    }
  }];
  return {
    FILTER_ITEMS: FILTER_ITEMS
  };
}